import { api, ApiError } from '@/services/api';

export { ApiError };

export interface SignupRequest {
  email: string;
  password: string;
  nome_empresa: string;
  slug?: string;
}

export interface SignupResponse {
  client_id: string;
  slug: string;
  package: string;
  trial_ends_at: string;
  access_token: string;
  token_type: string;
  expires_in: number;
  username: string;
  role: string;
  must_change_password: boolean;
}

export interface PlanoPreco {
  valor: string;
  moeda: 'BRL' | 'USD';
}

export interface PlanoItem {
  id: string;
  nome: string;
  preco: PlanoPreco;
  periodo: string;
  features: string[];
  destaque: boolean;
  /** Frase do catálogo dizendo o que o plano é. Opcional: pacote antigo não tem. */
  resumo?: string | null;
  /** A compra deste plano é conversa com vendas, não botão de checkout. */
  contato_vendas?: boolean;
}

export interface PlanosResponse {
  planos: PlanoItem[];
}

export interface AssinarRequest {
  package: string;
  gateway?: string;
  currency?: string;
}

export interface AssinaturaResponse {
  client_id: string;
  package: string;
  gateway: string;
  price: number | string;
  currency: string;
  status: string;
  psp_ref?: string | null;
  checkout_url?: string | null;
  motivo_sem_checkout?: string | null;
}

export interface CancelarResponse {
  ok: boolean;
  status: string;
  canceled_at: string;
}

export interface TrocarPacoteRequest {
  package: string;
}

export interface ConfirmarCheckoutRequest {
  session_id: string;
}

export interface ConfirmarCheckoutResponse {
  status: string;
  psp_ref: string | null;
  pagamento_confirmado: boolean;
}

export interface AssinaturaAtualResponse {
  package: string;
  status: string;
  price: number | string;
  currency: string;
  psp_ref: string | null;
  current_period_start: string | null;
  canceled_at: string | null;
}

export const funilApi = {
  signup: (data: SignupRequest): Promise<SignupResponse> =>
    api.post<SignupResponse>('/signup', data),

  getPlanos: (): Promise<PlanosResponse> => api.get<PlanosResponse>('/planos'),

  assinar: (data: AssinarRequest): Promise<AssinaturaResponse> =>
    api.post<AssinaturaResponse>('/billing/assinar', data),

  cancelar: (): Promise<CancelarResponse> => api.post<CancelarResponse>('/billing/cancelar'),

  trocarPacote: (data: TrocarPacoteRequest): Promise<AssinaturaResponse> =>
    api.post<AssinaturaResponse>('/billing/trocar-pacote', data),

  confirmarCheckout: (data: ConfirmarCheckoutRequest): Promise<ConfirmarCheckoutResponse> =>
    api.post<ConfirmarCheckoutResponse>('/billing/confirmar-checkout', data),

  getAssinatura: (): Promise<AssinaturaAtualResponse> =>
    api.get<AssinaturaAtualResponse>('/billing/assinatura'),
};
